import { publicUrl } from "shared/images/images";

export const categoryImg = {

    "Antiques": `${publicUrl}/static/images/Category/Antiques.webp`,
    "Art": `${publicUrl}/static/images/Category/Art.webp`,
    "Bedroom": `${publicUrl}/static/images/Category/Bedroom.webp`,
    "Books & Periodicals": `${publicUrl}/static/images/Category/Books & Periodicals.webp`,
    "Cameras & Photo Equipment": `${publicUrl}/static/images/Category/Camera & Photo.webp`,
    "Clothing & Accessories": `${publicUrl}/static/images/Category/Clothing & Accessories.webp`,
    "Coins": `${publicUrl}/static/images/Category/Coins.webp`,
    "Collectibles": `${publicUrl}/static/images/Category/Collectibles.webp`,
    "Craft & Hobby": `${publicUrl}/static/images/Category/Craft & Hobbies.webp`,
    "Decor": `${publicUrl}/static/images/Category/Decor.webp`,
    "Dining Room": `${publicUrl}/static/images/Category/Dining Room.webp`,
    "Electronics": `${publicUrl}/static/images/Category/Electronics.webp`,
    "Entertainment Cave": `${publicUrl}/static/images/Category/Entertainment Cave.webp`,
    "Farm": `${publicUrl}/static/images/Category/Farm.webp`,
    "Farm Equipment": `${publicUrl}/static/images/Category/Farm Equipment.webp`,
    "Furniture": `${publicUrl}/static/images/Category/Furniture.webp`,
    "Golf": `${publicUrl}/static/images/Category/Golf.webp`,
    "Household Goods": `${publicUrl}/static/images/Category/Household Goods.webp`,
    "Music": `${publicUrl}/static/images/Category/Instruments.webp`,
    "Jewelry": `${publicUrl}/static/images/Category/Jewelery.webp`,
    "Laundry Room": `${publicUrl}/static/images/Category/Laundry Room.webp`,
    "Motor Vehicles": `${publicUrl}/static/images/Category/Motor Vehicles.webp`,
    "Mystery Lots": `${publicUrl}/static/images/Category/Mystery.webp`,
    "Garage": `${publicUrl}/static/images/Category/Garage.webp`,
    "Office": `${publicUrl}/static/images/Category/Office.webp`,
    "Patio & Lawn": `${publicUrl}/static/images/Category/Patio & Lawn.webp`,
    "Railroad & Transportation": `${publicUrl}/static/images/Category/Railroad & Transportation.webp`,
    "Records": `${publicUrl}/static/images/Category/Records.webp`,
    "Sports & Hobbies": `${publicUrl}/static/images/Category/Sports & Hobbies.webp`,
    "Tools & Home Improvement": `${publicUrl}/static/images/Category/Tools & Home Renovation .webp`,
    "Toys": `${publicUrl}/static/images/Category/Toys.webp`,
    "Vintage": `${publicUrl}/static/images/Category/Vintage.webp`,
}
